import { bootstrapApplication } from '@angular/platform-browser';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.sentry.enabled && environment.sentry.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: `let-videollamada-ionic@${environment.appVersion}`,
    sendDefaultPii: true,
  });
}

// Consola dev (Eruda) para inspección en celular sin DevTools.
void (async () => {
  try {
    const params = new URL(location.href).searchParams;
    const queryFlag = params.get('debug');
    if (queryFlag === '1') localStorage.setItem('debug', '1');
    else if (queryFlag === '0') localStorage.removeItem('debug');
    if (localStorage.getItem('debug') === '1') {
      const eruda = (await import('eruda')).default;
      eruda.init();
    }
  } catch {
  }
})();

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
}).catch((err) => console.error(err));
